import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { IWarningProps } from './types';
import { plural } from '@cian/utils';

export const Warning = (props: IWarningProps) => {
  const { maxDays } = props;

  return (
    <UIText2 color="gray60_100">
      Редактировать адрес можно в течение {maxDays} {plural(maxDays, ['дня', 'дней', 'дней'])} после публикации
    </UIText2>
  );
};
